import { AppBarProps, AppBar as MUIAppBar } from "@mui/material";

type Props = AppBarProps;

export const AppBar = ({ children, ...props }: Props) => {
  return <MUIAppBar {...props}>{children}</MUIAppBar>;
};
